export default "__VITE_ASSET__DDd7DWs9__"